module.exports = __webpack_public_path__ + "img/logo-siemens.d80788c.jpg";